export default "__VITE_ASSET__BimuKaef__"